<fuse-drawer
    class="z-999 w-screen min-w-screen sm:w-100 sm:min-w-100"
    fixed
    [mode]="'over'"
    [name]="'settingsDrawer'"
    [position]="'right'"
    #settingsDrawer
>
    <div class="bg-card flex w-full flex-col overflow-auto">
        <div
            class="flex h-20 min-h-20 flex-row items-center bg-primary px-6 text-white"
        >
            <mat-icon
                class="text-current icon-size-7"
                [svgIcon]="'heroicons_solid:cog-8-tooth'"
            ></mat-icon>
            <div class="ml-3 text-2xl font-semibold tracking-tight">
                Settings
            </div>
            <button
                class="ml-auto"
                mat-icon-button
                (click)="settingsDrawer.close()"
            >
                <mat-icon
                    class="text-current"
                    [svgIcon]="'heroicons_outline:x-mark'"
                ></mat-icon>
            </button>
        </div>

        <div class="flex flex-col p-6">
            <!-- Theme -->
            <div class="text-secondary text-md font-semibold">THEME</div>
            <div class="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3">
                @for (theme of config.themes; track theme) {
                    <div
                        class="bg-hover flex cursor-pointer items-center justify-center rounded-full px-4 py-3 ring-inset ring-primary"
                        [class.ring-2]="config.theme === theme.id"
                        [ngClass]="theme.id"
                        (click)="setTheme(theme.id)"
                    >
                        <div
                            class="h-3 w-3 flex-0 rounded-full bg-primary"
                        ></div>
                        <div
                            class="ml-2.5 truncate font-medium leading-5"
                            [class.text-secondary]="config.theme !== theme.id"
                        >
                            {{ theme.name }}
                        </div>
                    </div>
                }
            </div>

            <!-- Layout section - Only show for Admin users who can choose between layouts -->
            @if (user && user.role === 'Admin') {
            <hr class="my-8" />

            <!-- Layout -->
            <div class="text-secondary text-md font-semibold">LAYOUT</div>
            <div class="mt-6 grid grid-cols-2 gap-3">
                <!-- Dense -->
                <div
                    class="flex cursor-pointer flex-col"
                    (click)="setLayout('dense')"
                >
                    <div
                        class="flex h-20 overflow-hidden rounded-md border-2 hover:opacity-80"
                        [class.border-primary]="config.layout === 'dense'"
                    >
                        <div class="w-4 bg-gray-100 dark:bg-gray-800">
                            <div
                                class="mx-auto mt-2 h-2 w-2 rounded-sm bg-gray-300 dark:bg-gray-700"
                            ></div>
                            <div
                                class="mt-2 flex w-full flex-col items-center space-y-1"
                            >
                                <div
                                    class="h-2 w-2 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-2 w-2 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-2 w-2 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-auto flex-col border-l">
                            <div class="h-3 bg-gray-100 dark:bg-gray-800">
                                <div
                                    class="mr-1.5 flex h-full items-center justify-end"
                                >
                                    <div
                                        class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="ml-1 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="text-secondary mt-2 text-center text-md font-medium"
                        [class.text-primary]="config.layout === 'dense'"
                    >
                        Dense
                    </div>
                    @if (saveLayoutSuccess && selectedLayout === 'dense') {
                        <div class="text-green-600 text-xs text-center mt-1 flex items-center justify-center">
                            <mat-icon class="mr-1" style="font-size: 14px; width: 14px; height: 14px;">check_circle</mat-icon>
                            Saved
                        </div>
                    }
                </div>

                <!-- Modern -->
                <div
                    class="flex cursor-pointer flex-col"
                    (click)="setLayout('modern')"
                >
                    <div
                        class="flex h-20 flex-col overflow-hidden rounded-md border-2 hover:opacity-80"
                        [class.border-primary]="config.layout === 'modern'"
                    >
                        <div
                            class="flex h-4 items-center border-b bg-gray-100 px-2 dark:bg-gray-800"
                        >
                            <div
                                class="h-2 w-2 rounded-full bg-gray-300 dark:bg-gray-700"
                            ></div>
                            <div class="ml-2 flex h-3 items-center space-x-1">
                                <div
                                    class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1 w-3 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                            <div
                                class="ml-auto flex items-center justify-end space-x-1"
                            >
                                <div
                                    class="h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-auto flex-col">
                            <div
                                class="flex flex-auto bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="text-secondary mt-2 text-center text-md font-medium"
                        [class.text-primary]="config.layout === 'modern'"
                    >
                        Modern
                    </div>
                    @if (saveLayoutSuccess && selectedLayout === 'modern') {
                        <div class="text-green-600 text-xs text-center mt-1 flex items-center justify-center">
                            <mat-icon class="mr-1" style="font-size: 14px; width: 14px; height: 14px;">check_circle</mat-icon>
                            Saved
                        </div>
                    }
                </div>
            </div>
            }
            
            @if (saveThemeSuccess) {
                <div class="text-green-600 text-sm mt-2 flex items-center">
                    <mat-icon class="mr-1" style="font-size: 18px; width: 18px; height: 18px;">check_circle</mat-icon>
                    Theme saved successfully!
                </div>
            }

            <!--
                Default login page for Admins in both layouts. This determines
                the route opened after sign-in; the modern-only Orders Workspace
                setting below independently controls the resting panel within
                /orders/list.
            -->
            @if (user && user.role === 'Admin') {
                <hr class="my-8" />
                <div class="text-secondary text-md font-semibold">DEFAULT PAGE ON LOGIN</div>
                <div class="mt-4">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Select default page on login</mat-label>
                        <mat-select
                            [value]="selectedLandingPage"
                            (selectionChange)="onLandingPageChange($event.value)"
                        >
                            @for (option of landingPageOptions; track option.value) {
                                <mat-option [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    @if (saveSuccess) {
                        <div class="text-green-600 text-sm mt-2 flex items-center">
                            <mat-icon class="mr-1" style="font-size: 18px; width: 18px; height: 18px;">check_circle</mat-icon>
                            Saved successfully!
                        </div>
                    }
                </div>
            }

            <!--
                Default Orders Workspace (Admin + modern layout only).
                Picks which workspace the /orders/list page rests in
                whenever any other panel (view / edit / new / duplicate /
                gallery / Uber / etc.) closes. "Blank / Idle" keeps the
                legacy behavior — no fallback, just an empty workspace.
            -->
            @if (user && user.role === 'Admin' && config?.layout === 'modern') {
                <hr class="my-8" />
                <div class="text-secondary text-md font-semibold">DEFAULT ORDERS WORKSPACE</div>
                <div class="text-secondary text-sm mt-2 mb-4">
                    Pick the panel that should always show on
                    <span class="font-medium">/orders/list</span> whenever
                    another workspace closes. Modern layout only.
                </div>
                <div class="mt-4">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Default workspace on close</mat-label>
                        <mat-select
                            [value]="selectedOrdersWorkspace"
                            (selectionChange)="onOrdersWorkspaceChange($event.value)"
                        >
                            @for (option of ordersWorkspaceOptions; track option.value) {
                                <mat-option [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    @if (saveOrdersWorkspaceSuccess) {
                        <div class="text-green-600 text-sm mt-2 flex items-center">
                            <mat-icon class="mr-1" style="font-size: 18px; width: 18px; height: 18px;">check_circle</mat-icon>
                            Saved successfully!
                        </div>
                    }
                </div>
            }

            <!--
                Landing Workspace (Trader + Independent-style Sales users).
                These roles have no layout / landing-page choice — just theme
                color (above) and the workspace their Orders page opens in.
            -->
            @if (showLandingWorkspacePicker) {
                <hr class="my-8" />
                <div class="text-secondary text-md font-semibold">LANDING WORKSPACE</div>
                <div class="text-secondary text-sm mt-2 mb-4">
                    Pick the panel that opens by default on your
                    <span class="font-medium">Orders</span> page.
                </div>
                <div class="mt-4">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Default workspace</mat-label>
                        <mat-select
                            [value]="selectedOrdersWorkspace"
                            (selectionChange)="onOrdersWorkspaceChange($event.value)"
                        >
                            @for (option of traderWorkspaceOptionsForRole; track option.value) {
                                <mat-option [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    @if (saveOrdersWorkspaceSuccess) {
                        <div class="text-green-600 text-sm mt-2 flex items-center">
                            <mat-icon class="mr-1" style="font-size: 18px; width: 18px; height: 18px;">check_circle</mat-icon>
                            Saved successfully!
                        </div>
                    }
                </div>
            }

            <!--
                Customer notifications (Trader + Independent Sales only).
                These reps brand their own outreach, so they choose whether
                their customers receive automatic order-status emails/texts.
            -->
            @if (showCustomerNotifyToggle) {
                <hr class="my-8" />
                <div class="text-secondary text-md font-semibold">CUSTOMER NOTIFICATIONS</div>
                <div class="text-secondary text-sm mt-2 mb-4">
                    When on, your customers automatically receive order-status
                    updates branded with your company identity.
                </div>
                <div class="mt-4">
                    <mat-checkbox
                        [color]="'primary'"
                        [checked]="notifyCustomers"
                        [disabled]="isSavingNotifyCustomers"
                        (change)="saveNotifyCustomers($event.checked)"
                    >
                        <span class="font-medium">Send order updates to customers</span>
                    </mat-checkbox>
                    @if (saveNotifyCustomersSuccess) {
                        <div class="text-green-600 text-sm mt-2 flex items-center">
                            <mat-icon class="mr-1" style="font-size: 18px; width: 18px; height: 18px;">check_circle</mat-icon>
                            Saved successfully!
                        </div>
                    }
                </div>
            }

            <!--
                Email header color (Trader + Independent Sales only).
                Applies to the banner behind your logo on customer-facing
                order notification emails.
            -->
            @if (showEmailBannerColorPicker) {
                <hr class="my-8" />
                <div class="text-secondary text-md font-semibold">EMAIL HEADER COLOR</div>
                <div class="text-secondary text-sm mt-2 mb-4">
                    Choose the banner color for order emails sent to your
                    customers. Your company logo appears on the right.
                </div>

                <!-- Live preview -->
                <div
                    class="mb-4 overflow-hidden rounded-xl border border-gray-200 dark:border-gray-700"
                    [style.background]="bannerGradient(selectedEmailBannerPreview)"
                >
                    <div class="flex items-center justify-between px-4 py-4">
                        <span
                            class="text-sm font-semibold sm:text-base"
                            [style.color]="selectedEmailBannerPreview.text"
                        >
                            Your order is in production
                        </span>
                        @if (userCompanyLogo) {
                            <img
                                [src]="userCompanyLogo"
                                alt="Company logo"
                                class="ml-3 max-h-10 max-w-[88px] object-contain"
                            />
                        } @else {
                            <span
                                class="text-xs font-medium opacity-80"
                                [style.color]="selectedEmailBannerPreview.text"
                            >
                                Your logo
                            </span>
                        }
                    </div>
                </div>

                <div class="grid grid-cols-4 gap-2 sm:grid-cols-5">
                    @for (color of emailBannerColors; track color.id) {
                        <button
                            type="button"
                            class="group relative flex aspect-square items-end overflow-hidden rounded-lg border-2 p-1 transition hover:scale-105"
                            [class.border-primary]="selectedEmailBannerColor === color.id"
                            [class.border-transparent]="selectedEmailBannerColor !== color.id"
                            [style.background]="bannerGradient(color)"
                            [disabled]="isSavingEmailBannerColor"
                            [matTooltip]="color.name"
                            (click)="selectEmailBannerColor(color.id)"
                        >
                            <span
                                class="w-full truncate rounded px-1 py-0.5 text-[10px] font-medium leading-tight backdrop-blur-sm"
                                [style.color]="color.text"
                                [style.background]="color.text === '#ffffff' ? 'rgba(0,0,0,0.15)' : 'rgba(255,255,255,0.35)'"
                            >
                                {{ color.name }}
                            </span>
                        </button>
                    }
                </div>
                @if (saveEmailBannerColorSuccess) {
                    <div class="text-green-600 text-sm mt-2 flex items-center">
                        <mat-icon class="mr-1" style="font-size: 18px; width: 18px; height: 18px;">check_circle</mat-icon>
                        Email color saved!
                    </div>
                }
            }

            @if (canAssignStation) {
                <hr class="my-8" />
                <div class="text-secondary text-md font-semibold">WAREHOUSE STATION</div>
                <div class="text-secondary text-sm mt-2 mb-4">
                    Carts you load are sent to this stop. Same list the robot uses:
                    press bays A–D and load spots 1–4.
                </div>
                <div class="text-secondary text-xs font-semibold uppercase tracking-wide mb-2">
                    Press bays
                </div>
                <div class="flex flex-wrap gap-2">
                    @for (spot of pressStations; track spot.id) {
                        <button
                            type="button"
                            mat-flat-button
                            [color]="selectedStationId === spot.id ? 'primary' : ''"
                            [disabled]="isSavingStation"
                            (click)="saveStation(spot.id)"
                        >
                            {{ spot.code }}
                        </button>
                    }
                </div>
                <div class="text-secondary text-xs font-semibold uppercase tracking-wide mt-4 mb-2">
                    Load spots
                </div>
                <div class="flex flex-wrap gap-2">
                    @for (spot of loadStations; track spot.id) {
                        <button
                            type="button"
                            mat-flat-button
                            [color]="selectedStationId === spot.id ? 'primary' : ''"
                            [disabled]="isSavingStation"
                            (click)="saveStation(spot.id)"
                        >
                            {{ spot.code }}
                        </button>
                    }
                    <button
                        type="button"
                        mat-stroked-button
                        [disabled]="isSavingStation"
                        (click)="saveStation(null)"
                    >
                        None
                    </button>
                </div>
                @if (saveStationSuccess) {
                    <div class="text-green-600 text-sm mt-3 flex items-center">
                        <mat-icon class="mr-1" style="font-size: 18px; width: 18px; height: 18px;">check_circle</mat-icon>
                        Station saved
                    </div>
                }
            }

            <!-- Assigned Work Page (Production users only) -->
            @if (user && user.role === 'Production') {
                <hr class="my-8" />
                <div class="text-secondary text-md font-semibold">ASSIGNED WORK PAGE</div>
                <div class="text-secondary text-sm mt-2 mb-4">
                    Select your specialized work page. This will be your primary admin function in addition to the default pages (Chat, Mailbox, Gallery).
                </div>
                <div class="mt-4">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Select your work page</mat-label>
                        <mat-select
                            [value]="selectedLandingPage"
                            (selectionChange)="onLandingPageChange($event.value)"
                        >
                            @for (option of productionLandingPageOptions; track option.value) {
                                <mat-option [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    @if (saveSuccess) {
                        <div class="text-green-600 text-sm mt-2 flex items-center">
                            <mat-icon class="mr-1" style="font-size: 18px; width: 18px; height: 18px;">check_circle</mat-icon>
                            Saved successfully!
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</fuse-drawer>